const isLoggedIn = window.wpData.isLoggedIn;
const userMenuBtn = document.querySelector('.ccare__flyout');
const mobileMenu = document.querySelector('.ccare__navscreen');
const mobileMenuOpen = document.querySelector('.ccare__nav-bar-hamburger');
const navScreenGroupOpen = document.querySelector('[aria-controls="NavScreenGroup"]');
const navScreenGroup = document.getElementById('NavScreenGroup');

// redirect to login page if not logged in and on homepage
if (!isLoggedIn && window.location.pathname === '/') {
	window.location.href = '/login';
}


/**
 * Event handlers for user menu interactions when user is logged in.
 * Handles mouseenter, mouseleave and click events on user menu button to show/hide menu.
 * Handles click events on mobile menu button and nav screen group button to show/hide menus.
*/

if (isLoggedIn) {
	// on mouseenter, change aria-expanded to true
	userMenuBtn.addEventListener('mouseenter', () => {
		userMenuBtn.setAttribute('aria-expanded', 'true');
	});

	// on click, change aria-expanded to the opposite of what it is
	userMenuBtn.addEventListener('click', () => {
		userMenuBtn.setAttribute(
			'aria-expanded',
			userMenuBtn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
		);
	});

	// on mouseleave, change aria-expanded to false
	userMenuBtn.addEventListener('mouseleave', () => {
		userMenuBtn.setAttribute('aria-expanded', 'false');
	});

	// on click of the hamburger menu, reveal the navscreen and change aria-expanded to true
	mobileMenuOpen.addEventListener('click', () => {
		mobileMenu.classList.toggle('ccare__navscreen--active');
		mobileMenuOpen.setAttribute(
			'aria-expanded',
			mobileMenuOpen.getAttribute('aria-expanded') === 'true' ? 'false' : 'true'
		);
	});

	// on click of the NavScreenGroup button, reveal the NavScreenGroup
	navScreenGroupOpen.addEventListener('click', () => {
		navScreenGroup.classList.toggle('ccare__items--active');
		navScreenGroupOpen.setAttribute(
			'aria-expanded',
			navScreenGroupOpen.getAttribute('aria-expanded') === 'true'
				? 'false'
				: 'true'
		);
	});
}

const companyList = document.querySelectorAll('.ccare__company-option');

/**
 * Iterates over the companyList and adds the 'ccare__company-option--active' class
 * to the company element that has a 'data-value' attribute equal to the companyId property of the window.wpData object.
 *
 * @param {NodeList} companyList - The list of company elements.
 */
companyList.forEach(company => {
	/**
	 * Checks if the 'data-value' attribute of the company element is equal to the companyId property of the window.wpData object.
	 * If true, adds the 'ccare__company-option--active' class to the company element.
	 */
	if (company.getAttribute('data-value') === window.wpData.companyId) {
		company.classList.add('ccare__company-option--active');
	}
});

/**
 * Responsive fix for Create New User button when sidebar is expanded
 * This ensures the button stays visible and properly sized on larger screens
 */
function handleCreateNewUserButtonResponsive() {
	const createNewUserBtn = document.getElementById('create-new-user-btn');
	const acctHeader = document.querySelector('.ccare__acct-header');
	
	if (createNewUserBtn && acctHeader) {
		// Check if we're on a large screen
		if (window.innerWidth >= 1200) {
			// Apply responsive styles
			createNewUserBtn.style.marginInline = 'unset';
			createNewUserBtn.style.width = '8.5rem';
			createNewUserBtn.style.flex = '0 0 auto';
			
			// Ensure header doesn't overflow
			acctHeader.style.overflow = 'visible';
			
			// Fix the button container
			const ctaContainer = acctHeader.querySelector('.ccare__layout-row.cta');
			if (ctaContainer) {
				ctaContainer.style.flexShrink = '0';
				ctaContainer.style.minWidth = 'fit-content';
			}
		} else {
			// Reset to default styles on smaller screens
			createNewUserBtn.style.marginInline = '';
			createNewUserBtn.style.width = '';
			createNewUserBtn.style.flex = '';
			acctHeader.style.overflow = '';
			
			const ctaContainer = acctHeader.querySelector('.ccare__layout-row.cta');
			if (ctaContainer) {
				ctaContainer.style.flexShrink = '';
				ctaContainer.style.minWidth = '';
			}
		}
	}
}

// Run on page load
document.addEventListener('DOMContentLoaded', function() {
	// Initial check
	handleCreateNewUserButtonResponsive();
	
	// Watch for window resize
	window.addEventListener('resize', handleCreateNewUserButtonResponsive);
	
	// Watch for sidebar toggle (if sidebar toggle exists)
	const sidebarToggle = document.querySelector('.cc-sidebar-toggle, #sidebarToggle');
	if (sidebarToggle) {
		sidebarToggle.addEventListener('click', function() {
			// Wait for sidebar transition to complete
			setTimeout(handleCreateNewUserButtonResponsive, 300);
		});
	}
});

// Also run when React components are loaded (for User Management page)
document.addEventListener('DOMContentLoaded', function() {
	// Use MutationObserver to watch for React component changes
	const observer = new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			if (mutation.type === 'childList') {
				// Check if the Create New User button was added
				const createNewUserBtn = document.getElementById('create-new-user-btn');
				if (createNewUserBtn) {
					handleCreateNewUserButtonResponsive();
				}
			}
		});
	});
	
	// Start observing
	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
});
